export default __webpack_public_path__ + "b004bb2390483910ea3eee2682db48ca.svg";